import { useState } from 'react';
import { SHARED_RESULTS_WRAPPER_ID } from '../../../utils/Controllers/Listing/PaginationController';

export default () => {
  const [isGrid, setGrid] = useState(false);
  const [wrapperEl] = useState(
    document.getElementById(SHARED_RESULTS_WRAPPER_ID),
  );
  const toggleView = newValue => {
    if (wrapperEl) {
      wrapperEl.classList[newValue ? 'add' : 'remove']('--lite');
      setGrid(newValue);
    }
  };
  return { isGrid, toggleView };
};
